import _ from 'lodash';
import React, { Component } from 'react';
import Slider from 'react-slick';
import { Link, browserHistory } from 'react-router';
import classnames from 'classnames';
import styles from './Carousel.css';

class HomeCarousel extends Component {
  projects = [
    {
      bgImage: process.env.PUBLIC_URL + '/imgs/home/2025/01.webp',
      name: 'McDonald\'s IP Rebranding 麥當勞',
      engName: 'McDonald\'s IP Rebranding',
    },
    {
      bgImage: process.env.PUBLIC_URL + '/imgs/home/2025/02.webp',
      name: 'good hands',
      engName: 'good hands',
    },
    {
      bgImage: process.env.PUBLIC_URL + '/imgs/home/2022/01.jpg',
      name: 'Fami!ce',
      engName: 'Fami!ce',
    },
    {
      bgImage: process.env.PUBLIC_URL + '/imgs/home/2022/02.jpg',
      name: 'FamiSuper',
      engName: 'FamiSuper',
    },
    {
      bgImage: process.env.PUBLIC_URL + '/imgs/home/2022/03.jpg',
      name: 'Calendar Project 2020',
      engName: 'Calendar Project 2020',
    },
    {
      bgImage: process.env.PUBLIC_URL + '/imgs/home/2022/05.jpg',
      name: 'OOO',
      engName: 'OOO',
    },
  ];

  constructor(props) {
    super(props);

    const initPage = _.random(0, this.projects.length);
    this.state = {
      currentProject: initPage,
    };
  }

  onClickDot(page) {
    this.setState({ currentProject: page });
    this.refs.slider.slickGoTo(page);
  }

  renderDots(currentPage) {
    const dotImages = [];
    for (let i = 0; i < this.projects.length; i += 1) {
      dotImages.push(
        <span
          className={classnames(styles.dot, {
            [styles.solidDot]: currentPage === i,
          })}
          key={`dot-${i}`}
          onClick={this.onClickDot.bind(this, i)}
        />,
      );
    }
    return <div className={styles.dots}>{dotImages}</div>;
  }

  renderCaption(currentProject) {
    const project = this.projects[currentProject];

    if (!project) {
      return null;
    }

    return (
      <section className="container">
        {this.renderDots(currentProject)}
        <p className={styles.projectLink}>
          {project.name},{' '}
          <Link to={`/projects/${project.engName}`}>View Project</Link>
        </p>
      </section>
    );
  }

  clickOnImage() {
    const { currentProject } = this.state;
    const project = this.projects[currentProject];

    browserHistory.push(`/projects/${project.engName}`);
  }

  slideBeforeChange(idx, nextIdx) {
    this.setState({ currentProject: nextIdx });
  }

  render() {
    const { currentProject } = this.state;
    const settings = {
      dots: false,
      arrows: false,
      autoplay: true,
      fade: true,
      lazyLoad: true,
      pauseOnHover: false,
      initialSlide: currentProject,
      beforeChange: this.slideBeforeChange.bind(this),
    };
    const slides = this.projects.map((project, idx) => (
      <div key={project.name}>
        <img
          src={project.bgImage}
          className={styles.coverImage}
          alt={project.name}
          onClick={this.clickOnImage.bind(this)}
        />
      </div>
    ));

    return (
      <div className={styles.homeCarousel}>
        <Slider ref="slider" {...settings}>
          {slides}
        </Slider>
        {this.renderCaption(currentProject)}
      </div>
    );
  }
}

export default HomeCarousel;



// WEBPACK FOOTER //
// ./src/components/carousel/Carousel.js